import styled, { css } from 'styled-components';

import { UploadedFileVideo } from '@/component/FileUpload/types';
import { useVimeoPlayer } from '@/administration/pages/Course/pages/assessments/practicalAssessmentVideo/variants/View/useVimeoPlayer';

type ViewPracticalAssessmentVideoPreviewVimeoProps = {
  uploadedFileVideo: UploadedFileVideo;
  rounded?: boolean;
};

const RootStyled = styled.div<{ $localRatio: number; $rounded?: boolean }>`
  width: 100%;
  border-radius: ${({ $rounded }) => ($rounded ? '12px' : '0px')};
  padding-bottom: ${({ $localRatio }) =>
    css`
      ${Math.floor($localRatio * 100)}%
    `};
`;

export const ViewPracticalAssessmentVideoPreviewVimeo = ({
  uploadedFileVideo,
  rounded,
}: ViewPracticalAssessmentVideoPreviewVimeoProps): JSX.Element => {
  const { playerElementId, videoRef, localRatio } = useVimeoPlayer({ uploadedFileVideo });

  return <RootStyled $rounded={rounded} id={playerElementId} ref={videoRef} className="video" $localRatio={localRatio} />;
};
